import React, { useMemo } from "react";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { Button, Form, Modal } from "antd";
import { delPack } from "../../../redux/JobModule/InProgressPage/InProgressAction";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useNavigate } from "react-router";

interface QcDetailDeleteModalProps {
  close: () => void;
  openState: boolean;
  open: () => void;
}

function QcDetailDeleteModal(props: QcDetailDeleteModalProps) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  //Getting each packID
  const packDetails = useSelector((state: RootState) => state.qCDetailPageState.data);

  //Modal Close Reseting the Fields
  const handleModalClose = () => {
    props.close();
    form.resetFields();
  };

  const DeleteModalContent = useMemo(() => {
    const onFinish = (value: any) => {
      props.close();
      form.resetFields();

      dispatch(delPack({ idPack: packDetails.idPack }));
      navigate("/auth/inprogress");
    };
    return (
      <div className="d-flex flex-column gap-4 w-100 modal-body-content">
        <h4> Delete Pack</h4>
        <p>Are you sure you want to delete this pack?</p>
        <div className="d-flex gap-3 justify-content-end">
          <Button
            style={{ color: "white", background: "#CCOOOO", boxShadow: "none" }}
            className="deleteButton"
            type="primary"
            htmlType="submit"
            onClick={onFinish}>
            Ok
          </Button>

          <Button
            className="cancelButton"
            htmlType="reset"
            onClick={handleModalClose}>
            Cancel
          </Button>
        </div>
      </div>
    );
  }, [form, packDetails]);

  return (
    <div>
      <Modal
        centered
        zIndex={1500}
        footer={[]}
        width={400}
        onCancel={handleModalClose}
        open={props.openState}>
        {DeleteModalContent}
      </Modal>
    </div>
  );
}

export default QcDetailDeleteModal;
